import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ff9800',
                secondary: '#03a9f4',
                accent: '#3f51b5',
                error: '#f44336',
                warning: '#fb8c00',
                info: '#00bcd4',
                success: '#4caf50'
            }
        }
    }
});
